// extracted by mini-css-extract-plugin
export var stack = "Stack-module--stack--6057c";